"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeLookupNode = void 0;
const utils_1 = require("../../utils");
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'ATTRIBUTE-LOOKUP';
const ID_KEY = 'id';
class AttributeLookupNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this.asynchronousResolver = async (nodeMap) => {
            if (this.accessorMap && this.accessorMap.OFFLINE_ATTRIB_LOOKUP) {
                const inputs = await this.asynchronousResolveInputs(nodeMap);
                const { aggregateType, aggregateId, attributeKey } = inputs;
                if (aggregateType && aggregateId && attributeKey) {
                    const aggregates = await Promise.resolve(this.accessorMap.OFFLINE_ATTRIB_LOOKUP(String(aggregateType), ID_KEY, aggregateId, 1));
                    if (aggregates.length > 0) {
                        const aggregate = aggregates[0];
                        const value = utils_1.getField(aggregate, String(attributeKey));
                        if (value) {
                            return {
                                output: String(value),
                            };
                        }
                    }
                }
            }
            return {
                output: null,
            };
        };
        this.synchronousResolver = (_nodeMap) => {
            throw new Error('Attribute lookup is not allowed as a synchronously resolving node');
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
}
exports.AttributeLookupNode = AttributeLookupNode;
AttributeLookupNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Attribute Lookup',
    isIdempotent: false,
    primaryCategory: 'Data Lookup',
};
//# sourceMappingURL=AttributeLookup.js.map